import { SearchPersonStatusResponse } from "@clockwise/schema";
import { SearchPersonFromGQL } from "../types";

export const convertSearchPersonToInviteSearchPerson = (
  person: SearchPersonFromGQL,
  isSuggested?: boolean,
) => {
  const profile = person.person.profile;
  const primaryCalendarId = person.person.primaryCalendarId;
  return {
    primaryCalendarId: primaryCalendarId,
    profile: {
      givenName: !!profile && !!profile?.givenName ? profile.givenName : primaryCalendarId, // if no user profile or givenName, show primaryEmail
      familyName: !!profile && !!profile?.familyName ? profile.familyName : "",
      externalImageUrl: !!profile && !!profile?.externalImageUrl ? profile.externalImageUrl : "",
    },
    isUser: person.status === SearchPersonStatusResponse.User,
    pending: person.status === SearchPersonStatusResponse.Invited,
    suggested: Boolean(isSuggested),
  };
};
